var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22290_32604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C11.266 0 0.5 10.766 0.5 24C0.5 37.234 11.266 48 24.5 48C37.734 48 48.5 37.234 48.5 24C48.5 10.766 37.734 0 24.5 0Z",
    fill: "#DC2626",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.5 0.5C37.65 0.5 48.352 11.132 48.488 24.25C48.488 24.166 48.5 24.084 48.5 24C48.5 10.766 37.734 0 24.5 0C11.266 0 0.5 10.766 0.5 24C0.5 24.084 0.512 24.166 0.512 24.25C0.648 11.132 11.352 0.5 24.5 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.5 47.5C11.35 47.5 0.648 36.868 0.512 23.75C0.512 23.834 0.5 23.916 0.5 24C0.5 37.234 11.266 48 24.5 48C37.734 48 48.5 37.234 48.5 24C48.5 23.916 48.488 23.834 48.488 23.75C48.352 36.868 37.648 47.5 24.5 47.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.4987 35.6666C30.942 35.6666 36.1654 30.4432 36.1654 23.9999C36.1654 17.5566 30.942 12.3333 24.4987 12.3333C18.0554 12.3333 12.832 17.5566 12.832 23.9999C12.832 30.4432 18.0554 35.6666 24.4987 35.6666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7346 24.0002L28.418 21.3168C28.7563 20.9785 28.7563 20.4185 28.418 20.0802C28.0796 19.7418 27.5196 19.7418 27.1813 20.0802L24.498 22.7635L21.8146 20.0802C21.4763 19.7418 20.9163 19.7418 20.578 20.0802C20.2396 20.4185 20.2396 20.9785 20.578 21.3168L23.2613 24.0002L20.578 26.6835C20.2396 27.0218 20.2396 27.5818 20.578 27.9202C20.753 28.0952 20.9746 28.1768 21.1963 28.1768C21.418 28.1768 21.6396 28.0952 21.8146 27.9202L24.498 25.2368L27.1813 27.9202C27.3563 28.0952 27.578 28.1768 27.7996 28.1768C28.0213 28.1768 28.243 28.0952 28.418 27.9202C28.7563 27.5818 28.7563 27.0218 28.418 26.6835L25.7346 24.0002Z",
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C11.266 0 0.5 10.766 0.5 24C0.5 37.234 11.266 48 24.5 48C37.734 48 48.5 37.234 48.5 24C48.5 10.766 37.734 0 24.5 0Z",
    fill: "url(#paint0_linear_22290_32604)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22290_32604",
    x1: 2.75,
    y1: 13.858,
    x2: 46.25,
    y2: 34.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22290_32604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTimes);
export default __webpack_public_path__ + "static/media/circle-times.5d3aa461.svg";
export { ForwardRef as ReactComponent };